import React from 'react'

import { Divider, DividerProps } from './Divider'

export const VerticalRule: React.FC<DividerProps> = (props) => (
  <Divider {...props} vertical />
)

VerticalRule.displayName = 'Content.VerticalRule'
